// Define all location fields that need to be cleared when resetting location
// This includes both core location data and form-specific metadata fields
export const LOCATION_FIELDS = [
  'address',
  'administrative_area_level_1',
  'administrative_area_level_2',
  'city',
  'colloquial_area',
  'country',
  'country_code',
  'lat',
  'lng',
  'location',
  'neighborhood',
  'postal_code',
  'sublocality_level_1',
  'sublocality_level_2',
  'bounds',
  // Form-specific metadata fields
  'location_level',
  'provider',
  'id',
  'online',
  'bias_code',
  'distance',
  'location_type',
];
